import { gql } from '@apollo/client';

export const QUERY_PRODUCTS = gql`
  query Products($publisher: ID!, $page: Int, $params: String) {
    products(publisher: $publisher, page: $page, params: $params) {
      id
      subtitle
      edition
      volume
      productWork {
        id
        title
        description
        imprint {
          id
          value
        }
        series {
          id
          value
        }
        publisher {
          id
          name
        }
      }
      isbn
      productcreatorSet {
        id
        creator {
          id
          displayName
        }
        onixContributorCode {
          id
          value
          description
        }
      }
      format {
        id
        value
        description
      }
      publicationDate
      shipDate
      inventoryQuantity
      retailPrice
      cartonQty
      weight
      width
      height
      thickness
      pageCount
      status {
        id
        value
        description
      }
      adminNotes
      coverImage
    }
  }
`
